import React, { useEffect, useState } from "react";
import { Dropdown } from "@fluentui/react-northstar";
import findIndex from "lodash/findIndex";
import { getSettings } from "../../services/settingsService";
import { getPreviousMondayDate, addDays } from "../../common/dateOperations";
import styles from "./weekPicker.module.scss";

export interface IWeekPickerProps {
    onChange: (startOfWeek: Date) => void;
}

const WeekPicker: React.FunctionComponent<IWeekPickerProps> = ({ onChange }) => {
    const [weeks, setWeeks] = useState(4);
    const [items, setItems] = useState<string[]>([]);
    const [selected, setSelected] = useState<string>("Aktuální týden");

    useEffect(() => {
        const { weeksToLoad } = getSettings();
        setWeeks(weeksToLoad);
    }, []);

    useEffect(() => {
        const currentMonday = getPreviousMondayDate(new Date());
        const count = weeks + 2;
        const tempItems = [
            "Aktuální týden",
            "Předchozí týden"
        ];
        for (let i = 2; i < count; i++) {
            const monday = addDays(currentMonday, 7 * -i);
            tempItems.push(`Týden od ${monday.getDate()}. ${monday.getMonth() + 1}`);
        }

        setItems([...tempItems]);
    }, [weeks]);

    const selectionChanged = (_: any, data: any) => {
        setSelected(data.value);

        const index = findIndex(items, (x: string) => x === data.value);
        const currentMonday = getPreviousMondayDate(new Date());
        const monday = index > 0 ? addDays(currentMonday, 7 * -index) : currentMonday;
        onChange(monday);
    };

    return (
        <Dropdown items={items} value={selected} onChange={selectionChanged} className={styles.weekInput} />
    );
};

export default WeekPicker;
